var _a;
export var mobile = function (breakpoint) { return "only screen and (max-width: ".concat(breakpoint - 1, "px)"); };
export var starRating = {
    margin: 0,
};
export var buttonRating = (_a = {
        marginLeft: '0px',
        flex: 1,
        whiteSpace: 'nowrap'
    },
    _a["& button"] = {
        minWidth: 'unset',
    },
    _a["@media ".concat(mobile(700))] = {
        width: '100%',
        display: 'block',
        marginBottom: '5px',
    },
    _a);
